(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionStatusDialogController', TransactionStatusDialogController);

    TransactionStatusDialogController.$inject = ['$state', '$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TransactionStatus'];

    function TransactionStatusDialogController($state, $timeout, $scope, $stateParams, $uibModalInstance, entity, TransactionStatus) {
        var vm = this;

        vm.transaction = entity;
        vm.clear = clear;
        vm.save = save;
        vm.status = $stateParams.status;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.transaction.id !== null) {
                TransactionStatus.update({id: vm.transaction.id, statusChangeReason: vm.transaction.statusChangeReason}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bozorakaAdminApp:transactionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
